import React, { useRef, useState } from 'react';
import PanelSheet from '../../components/PanelSheet';
import { Circle, Member, Filters, emptyFilters } from './model';
export function CircleFilters({
  value,
  set,
  close
}: {
  value: Filters;
  set: (value: Filters) => void;
  close: () => void;
}) {
  return <PanelSheet
    title="Çevre filtreleri"
    close={close}
    closeLabel="Filtreleri kapat"
    footer={<div className="flex gap-3">
    <button className="user-btn flex-1" onClick={() => set(emptyFilters)}>Sıfırla</button>
    <button className="user-btn-primary flex-1" onClick={close}>Sonuçları göster</button>
  </div>}
  >
    <label htmlFor="circle-size" className="user-label">Çevre büyüklüğü</label>
    <select id="circle-size" className="user-input" value={value.size} onChange={event => set({
      ...value,
      size: event.target.value
    })}>
      <option value="">Tüm büyüklükler</option>
      <option value="Small">Küçük · 0–2 üye</option>
      <option value="Medium">Orta · 3–5 üye</option>
      <option value="Large">Büyük · 6+ üye</option>
    </select>
    <h3 className="font-semibold text-sm mt-7 mb-4">Oluşturulma tarihi</h3>
    <label className="user-label" htmlFor="circle-from">Başlangıç</label>
    <input id="circle-from" className="user-input" type="date" value={value.from} onChange={event => set({
      ...value,
      from: event.target.value
    })} />
    <label className="user-label mt-4" htmlFor="circle-to">Bitiş</label>
    <input
      id="circle-to"
      className="user-input"
      type="date"
      min={value.from}
      value={value.to}
      onChange={event => set({
      ...value,
      to: event.target.value
    })}
    />
    {value.from && value.to && value.from > value.to && <p role="alert" className="text-sm text-red-600 mt-3">Bitiş tarihi başlangıç tarihinden önce olamaz.</p>}
    <p className="text-xs text-gray-500 mt-4">Oluşturulma tarihleri UTC saatine göre süzülür; bitiş gününün tamamı dahildir.</p>
  </PanelSheet>;
}
export function CircleConfirm({
  circle,
  member,
  close,
  submit
}: {
  circle: Circle;
  member?: Member;
  close: () => void;
  submit: () => Promise<void>;
}) {
  const [typed, setTyped] = useState('');
  const [busy, setBusy] = useState(false);
  const lock = useRef(false);
  const [error, setError] = useState('');
  const name = member ? member.full_name || member.username : circle.name;
  const confirm = async () => {
    if (lock.current || typed !== name) return;
    lock.current = true;
    setBusy(true);
    setError('');
    try {
      await submit();
      close();
    } catch {
      setError('İşlem tamamlanamadı. Yeniden deneyin.');
    } finally {
      lock.current = false;
      setBusy(false);
    }
  };
  return <PanelSheet
    compact
    title={member ? 'Üyeyi çıkar' : 'Çevreyi sil'}
    close={() => {
    if (!lock.current) close();
  }}
    closeLabel="Onayı kapat"
    busy={busy}
    footer={<div className="flex gap-3">
    <button className="user-btn flex-1" disabled={busy} onClick={close}>Vazgeç</button>
    <button className="user-btn-danger flex-1" disabled={busy || typed !== name} onClick={confirm}>
      {busy ? 'İşleniyor…' : member ? 'Üyeyi çıkar' : 'Çevreyi sil'}
    </button>
  </div>}
  >
    <p className="text-sm text-gray-600">
      {member ? `${name} (Kullanıcı #${member.id}), ${circle.name} çevresinden çıkarılsın mı?` : `${circle.name} (Çevre #${circle.id}) ve çevreye ait veriler silinsin mi? Bu işlem geri alınamaz.`}
    </p>
    <label className="user-label mt-6" htmlFor="circle-confirm-name">
      Onaylamak için “
      {name}
      ” yazın
    </label>
    <input id="circle-confirm-name" className="user-input" autoComplete="off" value={typed} onChange={event => setTyped(event.target.value)} disabled={busy} />
    {error && <p role="alert" className="text-sm text-red-600 mt-4">
      {error}
    </p>}
  </PanelSheet>;
}
